// src/pages/TermsOfService.tsx
const TermsOfService = () => {
  return (
    <div className="min-h-screen p-6 bg-background">
      <div className="max-w-4xl mx-auto space-y-8">
        <h1 className="text-4xl font-bold tracking-tight">Terms of Service</h1>
        <div className="prose prose-invert max-w-none">
          <p>Last updated: {new Date().toLocaleDateString()}</p>

          <h2>1. Acceptance of Terms</h2>
          <p>By accessing and using the Screen Tool, you agree to these terms of service.</p>

          <h2>2. Use License</h2>
          <p>We grant you a personal, non-exclusive license to use the Screen Tool for personal or commercial purposes.</p>

          <h2>3. Limitations</h2>
          <ul>
            <li>You must not modify or copy the software</li>
            <li>You must not use the service for illegal purposes</li>
            <li>You must not transmit malware or viruses</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;